import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PERFORMANCEAPPRAISAL,
  DELETE_PERFORMANCEAPPRAISAL,
  UPDATE_PERFORMANCEAPPRAISAL,
  ADD_NEW_PERFORMANCEAPPRAISAL,
} from "./actionType";

import {
  getPerformanceAppraisalSuccess,
  getPerformanceAppraisalFail,
  deletePerformanceAppraisalSuccess,
  deletePerformanceAppraisalFail,
  updatePerformanceAppraisalSuccess,
  updatePerformanceAppraisalFail,
  addPerformanceAppraisalSuccess,
  addPerformanceAppraisalFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approvePerformanceAppraisalApi,
  getPerformanceAppraisalApi,
  updatePerformanceAppraisalApi,
  deletePerformanceAppraisalApi,
  addNewPerformanceAppraisalApi
} from "../../helpers/backend_helper";

function* getPerformanceAppraisal({ payload: performanceAppraisal }) {
  try {
    const response = yield call(getPerformanceAppraisalApi, performanceAppraisal);
    yield put(getPerformanceAppraisalSuccess(GET_PERFORMANCEAPPRAISAL, response.data));
  } catch (error) {
    yield put(getPerformanceAppraisalFail(GET_PERFORMANCEAPPRAISAL, error));
  }
}

function* onUpdatePerformanceAppraisal({ payload: performanceAppraisal }) {
  try {
    if (performanceAppraisal.setApprove) {
      const response = yield call(approvePerformanceAppraisalApi, performanceAppraisal);
      yield put(updatePerformanceAppraisalSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePerformanceAppraisalApi, performanceAppraisal);
      yield put(updatePerformanceAppraisalSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePerformanceAppraisalFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePerformanceAppraisal({ payload: performanceAppraisal }) {
  try {
    const response = yield call(deletePerformanceAppraisalApi, performanceAppraisal);
    yield put(deletePerformanceAppraisalSuccess({ performanceAppraisal, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePerformanceAppraisalFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPerformanceAppraisal({ payload: performanceAppraisal }) {
  try {
    const response = yield call(addNewPerformanceAppraisalApi, performanceAppraisal);
    yield put(addPerformanceAppraisalSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPerformanceAppraisalFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPerformanceAppraisal() {
  yield takeEvery(GET_PERFORMANCEAPPRAISAL, getPerformanceAppraisal);
}

export function* watchUpdatePerformanceAppraisal() {
  yield takeEvery(UPDATE_PERFORMANCEAPPRAISAL, onUpdatePerformanceAppraisal);
}

export function* watchDeletePerformanceAppraisal() {
  yield takeEvery(DELETE_PERFORMANCEAPPRAISAL, onDeletePerformanceAppraisal);
}

export function* watchAddNewPerformanceAppraisal() {
  yield takeEvery(ADD_NEW_PERFORMANCEAPPRAISAL, onAddNewPerformanceAppraisal);
}

function* performanceAppraisalSaga() {
  yield all([
    fork(watchGetPerformanceAppraisal),
    fork(watchDeletePerformanceAppraisal),
    fork(watchUpdatePerformanceAppraisal),
    fork(watchAddNewPerformanceAppraisal)
  ]);
}

export default performanceAppraisalSaga;
